export default "__VITE_ASSET__DwbrygHN__"